import { useState } from 'react'
import { Button, Divider, Menu, MenuItem, Typography } from '@mui/material'
import { CONTROLS } from '~/components/Charts/chrome/chartChrome'

interface Props {
  availableDims: string[]
  activeDims: string[]
  onAddDim: (dim: string) => void
}

export function AddFilterMenu({ availableDims, activeDims, onAddDim }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  const inactiveDims = availableDims.filter((d) => !activeDims.includes(d))
  const activeForDisplay = availableDims.filter((d) => activeDims.includes(d))

  const handleSelect = (dim: string) => {
    setAnchorEl(null)
    onAddDim(dim)
  }

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        sx={{ borderStyle: 'dashed', borderRadius: 16, textTransform: 'none' }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        {CONTROLS.addFilter}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {inactiveDims.length === 0 ? (
          <MenuItem disabled>
            <Typography variant="caption">{CONTROLS.allFiltersActive}</Typography>
          </MenuItem>
        ) : (
          inactiveDims.map((dim) => (
            <MenuItem key={dim} onClick={() => handleSelect(dim)}>
              {dim}
            </MenuItem>
          ))
        )}
        {activeForDisplay.length > 0
          ? [
              <Divider key="divider" />,
              ...activeForDisplay.map((dim) => (
                <MenuItem key={dim} disabled sx={{ fontStyle: 'italic', opacity: 0.6 }}>
                  <Typography variant="caption">
                    {dim} — {CONTROLS.alreadyActive}
                  </Typography>
                </MenuItem>
              )),
            ]
          : null}
      </Menu>
    </>
  )
}
